import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { clearFormTemplate, createForm, getFormTemplate, getFormTemplates, updateForm } from 'actions/templates';
import PreviewFormTemplate from 'containers/FormTemplate/Display/PreviewFormTemplate';
import Moment from 'moment';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Expandable, List, Spinner } from 'UI';
import MultipleSectionSelector from './Partials/MultipleSectionSelector';
import { Checkbox, Button } from '@haldor/ui';

var SendDynamicForm = /*#__PURE__*/function (_Component) {
  _inherits(SendDynamicForm, _Component);

  var _super = _createSuper(SendDynamicForm);

  function SendDynamicForm(props) {
    var _this$state;

    var _this;

    _classCallCheck(this, SendDynamicForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters
        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onAbort != null) {
        _this.props.onAbort(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.templates == null) {
        _this.props.getFormTemplates();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (date) {
      var dueDate = Moment(date).set({
        hours: 23,
        minutes: 59,
        seconds: 59
      });

      _this.setState({
        dueDate: dueDate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      return new Promise(function (resolve) {
        values.formTemplateId = _this.state.form;
        values.status = 'PUBLISHED';
        values.dueDate = _this.state.dueDate.utc().format();

        if (values.formInstances == null) {
          values.formInstances = [];

          _this.state.sections.forEach(function (section) {
            if (_this.state.guardians) {
              section.guardians.forEach(function (guardian) {
                var instance = {
                  assignedTo: guardian.id
                };
                var inArray = values.formInstances.find(function (inst) {
                  return instance.assignedTo == inst.assignedTo;
                });

                if (inArray == null) {
                  values.formInstances.push(instance);
                }
              });
            } else {
              section.students.forEach(function (student) {
                var instance = {
                  assignedTo: student.id
                };
                var inArray = values.formInstances.find(function (inst) {
                  return instance.assignedTo == inst.assignedTo;
                });

                if (inArray == null) {
                  values.formInstances.push(instance);
                }
              });
            }
          });
        }

        if (_this.props.initialValues == null) {
          _this.props.createForm(values).then(function () {
            resolve(1);

            _this.props.onAbort(true);

            _this.props.history.push("form/".concat(_this.props.createdForm));
          });
        } else {
          _this.props.updateForm(values).then(function () {
            resolve(1);

            _this.props.onAbort();
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFormChange", function (event) {
      _this.setState({
        form: event.target.value
      });

      if (event.target.value != '0') {
        _this.setState({
          loading: true
        });

        _this.props.getFormTemplate(event.target.value).then(function () {
          _this.setState({
            loading: false
          });
        });
      } else {
        _this.props.clearFormTemplate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSectionsChange", function (selected) {
      _this.setState({
        sections: selected
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGuardiansChange", function (checked) {
      _this.setState({
        guardians: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextarea", function (_ref2) {
      var input = _ref2.input,
          label = _ref2.label,
          type = _ref2.type,
          placeholder = _ref2.placeholder,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error,
          warning = _ref2$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", _extends({}, input, {
        placeholder: placeholder || label,
        type: type
      }), input.value), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    var form = '0';

    if (props.activeForm != null) {
      form = props.activeForm.id;
    }

    var _dueDate = Moment().set({
      hours: 23,
      minutes: 59,
      seconds: 59
    });

    if (props.initialValues != null && props.initialValues.dueDate != null) {
      _dueDate = Moment(props.initialValues.dueDate);
    }

    _this.state = (_this$state = {
      form: form,
      dueDate: _dueDate,
      loading: false,
      sections: []
    }, _defineProperty(_this$state, "dueDate", _dueDate), _defineProperty(_this$state, "guardians", false), _this$state);
    return _this;
  }
  /* Helper methods */


  _createClass(SendDynamicForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          translate = _this$props.translate;
      var disableSave = false;

      if (this.state.sections.length == 0) {
        disableSave = true;
      }

      if (this.state.form == '0') {
        disableSave = true;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.onSubmit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: 0
        }
      }, translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "title",
        validate: this.required
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('description'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: this.renderTextarea,
        type: "textarea",
        name: "text",
        validate: this.required
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, translate('pick-end-time')), /*#__PURE__*/React.createElement(DatePicker, _extends({
        selected: this.state.dueDate,
        onChange: this.onDateChange,
        minDate: Moment(),
        popperModifiers: {
          preventOverflow: {
            enabled: true
          },
          positionFixed: false
        },
        popperPlacement: "bottom-start",
        selectsStart: true,
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: ""
      }, this.state.dueDate))), this.props.initialValues == null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('select-form-template'), "*"), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.state.form,
        onChange: this.onFormChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, this.props.translate('select')), this.props.templates != null ? this.props.templates.map(function (form) {
        return /*#__PURE__*/React.createElement("option", {
          value: form.id,
          key: form.id
        }, form.title);
      }) : null))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), this.props.initialValues == null ? /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginBottom: '0.55rem'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.guardians,
        onChange: this.onGuardiansChange,
        label: this.props.translate('select-guardians')
      })) : null, this.props.initialValues == null ? /*#__PURE__*/React.createElement(Expandable, {
        contentStyles: {
          padding: '1em 0rem'
        },
        contentStylesClosed: {
          padding: '0'
        },
        headerStyles: this.state.error != null ? {
          border: '1px solid red'
        } : {},
        whiteBackground: true,
        title: this.props.translate('choose-recipients')
      }, /*#__PURE__*/React.createElement(List, {
        style: {
          border: '0',
          margin: '0',
          boxShadow: '0'
        }
      }, /*#__PURE__*/React.createElement(MultipleSectionSelector, {
        mentorGroups: true,
        selectGuardians: this.state.guardians,
        onChange: this.onSectionsChange
      }))) : null, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, this.state.form != '0' && this.props.activeForm != null ? /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }) : null, this.state.form != '0' && this.props.activeForm != null && !this.state.loading ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 40
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          marginBottom: '.5rem'
        }
      }, translate('preview'))), /*#__PURE__*/React.createElement(PreviewFormTemplate, {
        fields: this.props.activeForm.fields
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid || disableSave
      }, translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onCancel,
        disabled: submitting,
        type: "secondary"
      }, translate('Cancel'))))));
    }
  }]);

  return SendDynamicForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    templates: state.Templates.templates,
    activeForm: state.Templates.formTemplate,
    initialValues: state.Templates.form,
    createdForm: state.Templates.createdForm
  };
}

export default withRouter(connect(mapStateToProps, {
  getFormTemplate: getFormTemplate,
  clearFormTemplate: clearFormTemplate,
  createForm: createForm,
  getFormTemplates: getFormTemplates,
  updateForm: updateForm
})(reduxForm({
  form: 'SendDynamicForm',
  destroyOnUnmount: true
})(SendDynamicForm)));